// Port of api/fuel/app/classes/filter/package/games/rating/package/rating.php
export default {
	run: function(pkg, local) {
		pkg.rating = local.rating ? {
			id: parseInt(local.rating.log_id || 0, 10),
			date: parseInt(local.rating.log_date || 0, 10),
			type: 2,
			context: parseInt(local.rating.log_context || 0, 10),
			user: parseInt(local.rating.user_id || 0, 10),
			game: parseInt(local.rating.game_id || 0, 10),
			rating: parseFloat(local.rating.log_rating || 0),
			previous: parseFloat(local.rating.log_previous || 0)
		} : false
		return pkg
	}
}
